import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { reportStyles } from "./styles";

export const ReportHeader = ({ title, subtitle, date, compact = false }) => {
  const headerStyle = compact ? reportStyles.headerCompact : reportStyles.header;
  const titleStyle = compact ? reportStyles.titleCompact : reportStyles.title;
  const dateStyle = compact ? reportStyles.dateCompact : reportStyles.date;

  return (
    <View style={headerStyle}>
      <View>
        <Text style={titleStyle}>{title}</Text>
        {subtitle && <Text style={reportStyles.subtitle}>{subtitle}</Text>}
      </View>
      <Text style={dateStyle}>{date || new Date().toLocaleDateString()}</Text>
    </View>
  );
};
